<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="60%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"    
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :packaging="packaging"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"        
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null,
      originalEntry: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,    
    packaging: Object,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(loadEntry) {
      this.loading = false
      // this.extraData = loadEntry;
      this.originalEntry = loadEntry;
      // this.editableEntry = _.cloneDeep(loadEntry);
      // console.log("editable", this.editableEntry);
      // console.log("entry", loadEntry);

      //  this.entry = loadEntry.itemLotAttributes;

      this.editableEntry = _.cloneDeep(this.originalEntry);
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: EDIT_PURCHASE_ITEM_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: loadEntry.id
          }
        })
        .then(response => {
          console.log("vali", response.data.accountContext.dummyEntryPurchaseItemLot.validations);
          this.editableEntry.validations = response.data.accountContext.dummyEntryPurchaseItemLot.validations;
          // this.editableEntry.validations.itemLotAttributes = response.data.accountContext.dummyEntryPurchaseItemLot.itemLotAttributes.validations;
          // console.log("terminou load!");
          // this.extraData = loadEntry.itemLotAttributes;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    updateEntry: function() {
      console.log("update item lot 1");
      if (this.$refs.form.isFormValid()){
        this.pageLoading = true;
        Object.assign(this.originalEntry, this.editableEntry);
        this.pageLoading = false;
        this.$refs.baseEdit.closeDialog();
        console.log("antes entry updated");
        this.$emit("entry-updated", this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const EDIT_PURCHASE_ITEM_QUERY = gql `
  query($id: ID!){
    accountContext {
      dummyEntryPurchaseItemLot(id: $id) {        
        validations        
      }
      allStorages {
        id
        name
        location
      }
    }
  }
`;
</script>

<style scoped></style>
